module.exports = {
    url: window.globalConfig.apiUrl
};
